export function convertDatesToISO(
  obj: Record<string, any> | any[] | undefined,
): Record<string, any> | any[] | undefined {
  if (!obj) return obj

  if (Array.isArray(obj)) {
    return obj.map((item) =>
      item instanceof Date
        ? item.toISOString()
        : typeof item === 'object'
        ? convertDatesToISO(item)
        : item,
    )
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value instanceof Date) {
      acc[key] = value.toISOString()
    } else if (Array.isArray(value)) {
      acc[key] = convertDatesToISO(value)
    } else if (typeof value === 'object' && value !== null) {
      acc[key] = convertDatesToISO(value)
    } else {
      acc[key] = value
    }
    return acc
  }, {} as Record<string, any>)
}
